
import Utility from '@/components/Passenger/models/Utility';
import RideitChangeRequest from '@/models/Rideit/RideitChangeRequest';
import { IDataTableHeader } from '@/typings/dataTable';
import { Component, Prop, Vue } from 'vue-property-decorator';
import RideitChangeRequestTableItem from './RideitChangeRequestTableItem.vue';

@Component({
  components: {
    RideitChangeRequestTableItem,
  }
})
export default class RideitChangeRequestTable extends Vue {
  @Prop({ default: () => [] }) private changeRequests: RideitChangeRequest[];
  @Prop({ default: false }) private loading: boolean;
  @Prop({ default: '' }) private errorMessage: string;
  @Prop({ default: () => [] }) private utilityOptions: Utility[];

  headers: IDataTableHeader[] = [
    { text: this.$t('passenger.prop.name.label'), value: 'passengerName', sortable: true },
    { text: this.$t('rideIt.changeRequests.request'), value: 'Apuväline', sortable: true },
    { text: this.$t('passenger.prop.phoneNumbers.label'), value: 'createdByPhone', sortable: true },
    { text: this.$t('generic.status'), value: 'status', sortable: true },
  ];
}
